<template>
  <div>
    <div class="row" v-if="!computedImach">
      <div class="col-xl-3 col-md-6" v-if="permission('show_year')">
        <div v-if="fatAno == cardYear.data.length">
          <stats-card
            :title="`R$ ${parseFloat(parseFloat(cardYear.total_yearly.total_yearly)).toLocaleString('pt-BR')}`"
            :subTitle="`Faturamento em ${(new Date).getFullYear()}`"
          >
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-chart-pie-36 text-warning"></i>
            </div>
            <template slot="footer">
              <div class="stats">
                <i class="fa fa-history"></i>
                Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}

                <i style="margin-left: 20px"
                  @click="arrowLeft()"
                  class="fa fa-angle-left"></i>
              </div>
            </template>
          </stats-card>
        </div>
        <div v-else>
          <stats-card
            :title="`R$ ${parseFloat(parseFloat(cardYear.data[fatAno].total)).toLocaleString('pt-BR')}`"
            :subTitle="`Faturamento na máquina ${cardYear.data[fatAno].vm__location} em ${(new Date).getFullYear()}`"
          >
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-chart-pie-36 text-warning"></i>
            </div>
            <template slot="footer">
              <div class="stats">
                <i class="fa fa-history"></i>
                Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}

                <i style="margin-left: 20px"
                  v-if="fatAno !== 0"
                  @click="arrowLeft()"
                  class="fa fa-angle-left"></i>
                <i style="margin-left: 5px"
                  @click="arrowRight()" class="fa fa-angle-right"></i>
              </div>
            </template>
          </stats-card>
        </div>
      </div>
      <div class="col-xl-3 col-md-6" v-if="topDay && permission('show_day')" >
        <stats-card
          :title="topDay.title"
          :subTitle="`Mais vendido em ${(new Date).toLocaleDateString('pt-BR')}`"
        >
          <div slot="header" class="icon-danger">
            <i class="nc-icon nc-favourite-28 text-danger"></i>
          </div>
          <template slot="footer">
            <div class="stats">
              <i class="fa fa-history"></i>
              Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}
            </div>
          </template>
        </stats-card>
      </div>
      <div class="col-xl-3 col-md-6" v-if="!topDay && permission('show_day')">
        <stats-card
          title="Nenhuma venda"
          :subTitle="`Mais vendido em ${(new Date).toLocaleDateString('pt-BR')}`"
        >
          <div slot="header" class="icon-danger">
            <i class="nc-icon nc-favourite-28 text-danger"></i>
          </div>
          <template slot="footer">
            <div class="stats">
              <i class="fa fa-history"></i>
              Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}
            </div>
          </template>
        </stats-card>
      </div>

      <div class="col-xl-3 col-md-6" v-if="permission('show_monthlySum')">
        <div v-if="fatMes == cardMonth.data.length">
          <stats-card
            :title="`R$ ${parseFloat(parseFloat(cardMonth.total_monthly.total_monthly).toFixed(2)).toLocaleString('pt-BR')}`"
            :subTitle="`Faturamento em ${fullMonths[(new Date).getMonth()]}`"
          >
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-chart-bar-32 text-success"></i>
            </div>
            <template slot="footer">
              <div class="stats">
                <i class="fa fa-history"></i>
                Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}

                <i style="margin-left: 20px"
                  @click="arrowLeft2()"
                  class="fa fa-angle-left"></i>
              </div>
            </template>
          </stats-card>
        </div>
        <div v-else>
          <stats-card
            :title="`R$ ${parseFloat(parseFloat(cardMonth.data[fatMes].total).toFixed(2)).toLocaleString('pt-BR')}`"
            :subTitle="`Faturamento na máquina ${cardMonth.data[fatMes].vm__location} em ${fullMonths[(new Date).getMonth()]}`"
          >
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-chart-bar-32 text-success"></i>
            </div>
            <template slot="footer">
              <div class="stats">
                <i class="fa fa-history"></i>
                Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}

                <i style="margin-left: 20px"
                  v-if="fatMes !== 0"
                  @click="arrowLeft2()"
                  class="fa fa-angle-left"></i>
                <i style="margin-left: 5px"
                  @click="arrowRight2()" class="fa fa-angle-right"></i>
              </div>
            </template>
          </stats-card>
        </div>
      </div>
      <div class="col-xl-3 col-md-6" v-if="topMonth && permission('show_monthly')" >
        <stats-card
          :title="topMonth.title"
          :subTitle="`Mais vendido em ${fullMonths[(new Date).getMonth()]}`"
        >
          <div slot="header" class="icon-primary">
            <i class="nc-icon nc-spaceship text-primary"></i>
          </div>
          <template slot="footer">
            <div class="stats">
              <i class="fa fa-history"></i>
              Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}
            </div>
          </template>
        </stats-card>
      </div>

      <div class="col-xl-3 col-md-6" v-if="!topMonth && permission('show_monthly')">
        <stats-card
          title="Nenhuma venda"
          :subTitle="`Mais vendido em ${fullMonths[(new Date).getMonth()]}`"
        >
          <div slot="header" class="icon-primary">
            <i class="nc-icon nc-spaceship text-primary"></i>
          </div>
          <template slot="footer">
            <div class="stats">
              <i class="fa fa-history"></i>
              Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}
            </div>
          </template>
        </stats-card>
      </div>
      
    </div>
    <div class="row" v-if="!computedImach">
      <!-- <div class="col-md-4">
        <chart-card :chart-data="pieChart.data" chart-type="Pie">
          <template slot="header">
            <h4 class="card-title">Email Statistics</h4>
            <p class="card-category">Last Campaign Performance</p>
          </template>
          <template slot="footer">
            <div class="legend">
              <i class="fa fa-circle text-info"></i> Open
              <i class="fa fa-circle text-danger"></i> Bounce
              <i class="fa fa-circle text-warning"></i> Unsubscribe
            </div>
            <hr>
            <div class="stats">
              <i class="fa fa-clock-o"></i> Campaign sent 2 days ago
            </div>
          </template>
        </chart-card>
      </div>-->
      <div class="col-xl-6 col-md-12" v-if="yearlyOk && permission('show_grapfhYear')">
        <chart-card
          :chart-data="yearlyChart.data"
          :chart-options="yearlyChart.options"
          :responsive-options="lineChart.responsiveOptions"
        >
          <template slot="header">
            <h4 class="card-title">Faturamento em {{(new Date).getFullYear()}}</h4>
            <p class="card-category">Mensalmente desde o início do ano (R$)</p>
          </template>
          <template slot="footer">
            <hr />
            <div class="stats">
              <i class="fa fa-history"></i>
              Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}
            </div>
          </template>
        </chart-card>
      </div>
      <!-- aqui -->
      <div class="col-xl-6 col-md-12" v-if="monthlyOk && permission('show_grapfhMonth')">
        <chart-card
          :chart-data="monthlyChart.data"
          :chart-options="monthlyChart.options"
          :responsive-options="lineChart.responsiveOptions"
        >
          <template slot="header">
            <h4 class="card-title">Faturamento em {{ fullMonths[(new Date).getMonth()] }}</h4>
            <p class="card-category">Diariamente desde o início do mês (R$)</p>
          </template>
          <template slot="footer">
            <hr />
            <div class="stats">
              <i class="fa fa-history"></i>
              Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}
            </div>
          </template>
        </chart-card>
      </div>
      <!-- aqui -->
    </div>
    <div class="row" >
      <div class="col-md-6" v-if="!computedImach">
        <card class="card-tasks" title="Produtos" subTitle="Próximos ao vencimento">
          <el-table :data="tableData" :row-class-name="colorRow" style="width: 100%">
            <el-table-column prop="vm_location" label="VM" width="120%"></el-table-column>
            <el-table-column prop="vm_position" label="Mola" width="60%"></el-table-column>
            <el-table-column prop="product_name" label="Produto"></el-table-column>
            <el-table-column prop="product_variant_name" label="Variação"></el-table-column>
            <el-table-column prop="expiration_date" label="Data" width="120%"></el-table-column>
          </el-table>
          <div class="stats" slot="footer">
            <i class="fa fa-history"></i>
            Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}
          </div>
        </card>
      </div>
      <div class="col-md-6" v-if="!isImach">
        <card class="card-tasks" title="Produtos" subTitle="Próximos a esgotar">
          <el-table :data="tableDataEstoque" :row-class-name="colorRow" style="width: 100%">
            <el-table-column prop="vm_location" label="VM" width="110%"></el-table-column>
            <el-table-column prop="vm_position" label="Mola" width="55%"></el-table-column>
            <el-table-column prop="product_name" label="Produto"></el-table-column>
            <el-table-column prop="product_variant_name" label="Variação"></el-table-column>
            <el-table-column prop="capacity" label="Capacidade" width="100%"></el-table-column>
            <el-table-column prop="amount" label="Quantidade" width="100%"></el-table-column>
          </el-table>
          <div class="stats" slot="footer">
            <i class="fa fa-history"></i>
            Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}
          </div>
        </card>
      </div>
      <div class="col-md-6" v-if="!isImach">
        <card class="card-tasks" title="Status das VMs" >
          <el-table :data="tableStatus()" :row-class-name="colorStatus" style="width: 100%">
            <el-table-column prop="location" label="VM" ></el-table-column>
            <el-table-column prop="updated" label="Último contato" ></el-table-column>
            <el-table-column prop="online" label="Status"></el-table-column>
          </el-table>
          <div class="stats" slot="footer">
            <i class="fa fa-history"></i>
            Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}
          </div>
        </card>
      </div>
      <div class="col-md-12" v-if="isImach">
        <card class="card-tasks" title="Status das VMs" >
          <el-table :data="tableStatus()" :row-class-name="colorStatus" style="width: 100%" v-if="showStatus">
            <el-table-column prop="location" label="VM" ></el-table-column>
            <el-table-column prop="updated" label="Último contato" ></el-table-column>
            <el-table-column prop="online" label="Status"></el-table-column>
          </el-table>
          <div class="stats" slot="footer">
            <i class="fa fa-history"></i>
            Atualizado às {{(new Date).toLocaleTimeString('pt-BR')}}
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ChartCard,
  StatsCard,
  Card,
  Table as LTable,
  Checkbox
} from "src/components/index";

import Chartist from 'chartist';
import { Table, TableColumn, Select, Option } from "element-ui";
import * as ChartistTooltips from 'chartist-plugin-tooltips'
export default {
  components: {
    Checkbox,
    Card,
    LTable,
    ChartCard,
    StatsCard,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select
  },
  computed: {
    count() {
      return this.$store.state.count;
    },
    isImach() {
      console.log('store', this.$store)
      const imach = localStorage.getItem("imach")
      if (imach == 'true') {
        this.computedImach = true
        return true
      } else {
        this.computedImach = false
        return false
      }
    },
    tableData () {
      const expire = this.$store.state.general.compExpire
      const populated = expire.map(v => {
        let expiration_date, color, diffDays
        if (v.expiration_date) {
          expiration_date = this.formatDate(v.expiration_date)
          const date1 = new Date(v.expiration_date);
          const date2 = new Date();
          const diffTime = Math.floor(date1 - date2);
          diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        }
        if (diffDays <= 0) {
          color = 'red'
        }
        if (1 <= diffDays && diffDays <= 5) {
          color =   'orange'
        }
        if (5 < diffDays && diffDays <= 10) {
          color =  'yellow'
        }
        if (diffDays > 10) {
          color = ''
        }

        return {...v, expiration_date, color}
      })
      return populated
    },
    tableDataEstoque () {
      const soldOut = this.$store.state.general.compSoldOut
      var populated = soldOut.map(v => {
        let percent, color

        percent = (v.amount*100)/v.capacity

        if (percent < 1) {
          color = 'red'
        }
        if (1 <= percent && percent <= 5) {
          color =   'orange'
        }
        if (5 < percent && percent <= 10) {
          color =  'yellow'
        }
        if (percent > 10) {
          color = ''
        }
        if (!v.active) {
          color = 'green'
        }

        return {...v, color}
      })
      return populated      
    },
    yearlySum() {
      if (this.yearly.length < 1) return "0";
      console.log('ano', this.yearly)
      return this.yearly
      // return this.yearly
      //   .map(v => v.total)
      //   .reduce((sum, value) => sum + value)
      //   .toString();
    },
    monthlySum() {
      if (this.monthly.length < 1) return "0";
      console.log('mes', this.monthly)
      return '0'
      // return this.monthly
      //   .map(v => v.total)
      //   .reduce((sum, value) => sum + value)
      //   .toString();
    },
    yearlyChart() {
      const totals = this.yearly.map(v => v.total);
      const max = Math.max(...totals) * 1.1;

      return {
        options: {
          low: 0,
          high: max,
          showArea: false,
          height: "245px",
          axisX: {
            showGrid: false
          },
          lineSmooth: true,
          showLine: true,
          tooltip: true,
          showPoint: true,
          fullWidth: true,
          plugins: [Chartist.plugins.tooltip()],
          chartPadding: {
            right: 50,
            left: 10
          }
        },
        data: {
          labels: this.months,
          series: [[...totals]]
        }
      };
    },
    monthlyChart() {
      const totals = this.monthly.map(v => {
        if (v.total === null) {
          v.total = 0
        }
        return v.total
      });
      console.log('tota', totals)
      const max = Math.max(...totals) * 1.1;
      const dates = this.monthly.map(v => v.day);
      // const days = dates.map(v => v.split("-")[2]);
      const days = dates
      const oddDays = days.map(v => (v % 2 === 0 ? "" : v));

      return {
        options: {
          low: 0,
          high: max,
          showArea: false,
          height: "245px",
          axisX: {
            showGrid: false
          },
          lineSmooth: true,
          showLine: true,
          showPoint: true,
          fullWidth: true,
          plugins: [Chartist.plugins.tooltip()],
          chartPadding: {
            right: 50
          }
        },
        data: {
          labels: oddDays,
          series: [[...totals]]
        }
      };
    },
    yearly() {
      return this.$store.state.charts.yearly;
    },
    monthly() {
      return this.$store.state.charts.monthly;
    },
    topYear() {
      return this.$store.state.charts.topYear;
    },
    topDay() {
      return this.$store.state.charts.topDay;
    },
    topMonth() {
      return this.$store.state.charts.topMonth;
    },
    products() {
      return this.$store.state.products.products;
    },
  },
  methods: {
    arrowRight () {
      this.fatAno += 1
    },
    arrowLeft () {
      this.fatAno -= 1
    },
    arrowRight2 () {
      this.fatMes += 1
    },
    arrowLeft2 () {
      this.fatMes -= 1
    },
    permission (permissao) {
      if (this.isImach) {
        return true
      }
      if (this.$store.state.general.permission.permissoes_do_usuario !== undefined) {
        var x = this.$store.state.general.permission.permissoes_do_usuario.filter(el => {
          if (el === permissao) {
            return el
          } 
        })
        if (x.length > 0) {
          return true
        }
      }
    },
    increment() {
      this.$store.commit("increment");
    },
    decrement() {
      this.$store.state.count--;
    },
    colorRow({row, rowIndex}) {
      if (row.color === 'red') {
        return 'vencido-row';
      } else if (row.color === 'orange') {
        return 'cincodias-row';
      } else if (row.color === 'yellow') {
        return 'dezdias-row'
      } else if (row.color === 'green') {
        return 'desativado-row'
      }
      return '';
    },
    colorStatus({row, rowIndex}) {
      if (row.online === 'Off-line') {
        return 'vencido-row';
      } else if (row.online === 'On-line') {
        return 'online-row'
      }
      return '';
    },
    getStatus () {
      const ciaName = localStorage.getItem('imachCia')
      const ciaID = localStorage.getItem('imachCiaID')
        if (this.computedImach && ciaID) {
          this.$store.dispatch('general/statusVM', {search: '?company=' + ciaID}).then(data => {
            this.statusVM = data
            this.tableStatus()
          })
        } else {
          this.$store.dispatch('general/statusVM', {search: ''}).then(data => {
            this.statusVM = data
            this.tableStatus()
          })
        }
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(data => {
        this.companyList = data
      })
    },
    // getListCompany() {
    //   if (this.$store.state.auth.company != null) {
    //     this.$store.dispatch("general/listUser").then(() => {
    //       var x = this.$store.state.general.listUser.user_list_info;
    //       this.companyList = x.filter(
    //         (thing, index, self) =>
    //           index ===
    //           self.findIndex(
    //             t =>
    //               t.profile__company__id === thing.profile__company__id &&
    //               t.profile__company__name === thing.profile__company__name
    //           )
    //       );
    //     });
    //     console.log('store', this.$store.state)
    //   }
    // },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    tableStatus () {
      const vmStatus = this.statusVM.map(v =>{
        let location, online, updated

        location = v.location
        var startDate = Date.parse(v.last_communication)
        var finalDate = Date.now()
        var dif = finalDate -startDate
        // 5 min em milisegundos
        if (dif <= 300000) {
          online = "On-line"
        } else {
          online = "Off-line"
        }

        const d = new Date(v.last_communication);
        const created = d.toLocaleString("pt-BR");
        updated = created

        return {...v, location, online, updated} 
      })
      console.log('tablestatus', vmStatus)
      this.showStatus = true
      return vmStatus
    },
  },
  mounted() {
    this.getListCompany();
    this.$store.dispatch("products/list").then(() => {
      this.$store.dispatch("charts/getTopMonth")
      this.$store.dispatch("charts/getTopDay").then(()=> {
      })
       this.$store.dispatch("charts/getCardMonth").then(resp => {
        this.cardMonth = resp
        console.log('cardmes', resp)
      });
       this.$store.dispatch("charts/getCardYear").then(resp => {
        this.cardYear = resp
        console.log('cardano', resp)
      });
      this.$store.dispatch("charts/getYearly").then(resp => {
        this.yearlyOk = true;
        console.log('reques', resp)
        this.yearly = resp
      });
      this.$store.dispatch("charts/getMonthly").then(() => {
        this.monthlyOk = true;
      });
    });
    if (this.$store.state.auth.company != null) {
      this.$store.dispatch('general/companyExpire', {id: this.$store.state.auth.company})
    }
    this.getStatus()

    if (this.$store.state.auth.company != null) {
      this.$store.dispatch('general/companySoldOut', {id: this.$store.state.auth.company})
    }
    this.getListCompany();
    this.$watch('compSelect', () =>{
      if (this.compSelect === null) {
        this.showStatus = false
      } else {
        this.getStatus()
      }
    })
    // setInterval(function() {
    //   window.location.reload();
    // }, this.$store.state.general.timer);
  },
  data() {
    return {
      months: [
        "JAN",
        "FEV",
        "MAR",
        "ABR",
        "MAI",
        "JUN",
        "JUL",
        "AGO",
        "SET",
        "OUT",
        "NOV",
        "DEZ"
      ],
      fullMonths: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      yearlyOk: false,
      statusVM: [],
      showStatus: false,
      fatAno: 0,
      fatMes: 0,
      compSelect : '',
      cardMonth: [],
      cardYear: [],
      monthlyOk: false,
      editTooltip: "Edit Task",
      deleteTooltip: "Remove",
      companyList: [],
      pieChart: {
        data: {
          labels: ["40%", "20%", "40%"],
          series: [40, 20, 40]
        }
      },
      lineChart: {
        data: {
          labels: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO"],
          series: [
            [287, 385, 490, 492, 554, 586, 698, 695],
            [67, 152, 143, 240, 287, 335, 435, 437],
            [23, 113, 67, 108, 190, 239, 307, 308]
          ],
        },
        options: {
          low: 0,
          high: 800,
          showArea: false,
          height: "245px",
          axisX: {
            showGrid: false
          },
          lineSmooth: true,
          showLine: true,
          showPoint: true,
          fullWidth: true,
          chartPadding: {
            right: 50
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },
      barChart: {
        data: {
          labels: [
            "Janeiro",
            "Feb",
            "Mar",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
            [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]
          ]
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: "245px"
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },
    };
  }
};
</script>
<style>
  .el-table .vencido-row {
    background: rgb(247, 161, 161);
  }
  .el-table .cincodias-row {
    background: #f7bc6f;
  }
  .el-table .dezdias-row {
    background: #fdff6b;
  }
  .el-table .desativado-row {
    display: none;
  }
  .el-table .online-row {
    background: rgb(179, 255, 179);
  }
  
.chartist-tooltip {
    position: absolute;
    display: none;
    min-width: 5em;
    padding: 8px 10px;
    background: #383838;
    margin-top: 100px;
    color: #fff;
    text-align: center;
    pointer-events: none;
    z-index: 100;
    transition: opacity .2s linear;
  }

  .chartist-tooltip:before {
    position: absolute;
    bottom: -14px;
    left: 50%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    pointer-events: none;
    border-color: rgba(251, 249, 228, 0);
    border-top-color: #383838;
    border-width: 7px;
    margin-left: -8px;
  }

  .chartist-tooltip.tooltip-show {
      display: inline-block !important;
  }
  .ct-label {
    margin-left: 3px
  }
  .span.ct-label.ct-vertical.ct-start {
    color: red;
  }

</style>
